import { ConversationPanel } from "./ConversationPanel";

interface Props {
  projectId: string;
  currentUserId: string;
  isDirector: boolean;
  isCeo: boolean;
}

export function ProjectConversations({ projectId, currentUserId, isDirector, isCeo }: Props) {
  const canDirector = isDirector || isCeo;

  if (!canDirector) return null;

  return (
    <div className="mb-8">
      <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-3">Konwersacje</h2>
      <div className={`grid gap-4 ${isCeo ? "grid-cols-1 lg:grid-cols-2" : "grid-cols-1"}`}>
        {/* Director conversation — visible to directors and CEOs */}
        <ConversationPanel
          key={`${projectId}-director`}
          projectId={projectId}
          conversationType="director"
          title="Konwersacja dyrektorska"
          currentUserId={currentUserId}
          isCeo={isCeo}
        />

        {/* Board conversation — visible only to CEOs */}
        {isCeo && (
          <ConversationPanel
            key={`${projectId}-board`}
            projectId={projectId}
            conversationType="board"
            title="Konwersacja zarządu"
            currentUserId={currentUserId}
            isCeo={isCeo}
          />
        )}
      </div>
    </div>
  );
}
